import { FaPhoneAlt, FaPhoneVolume } from 'react-icons/fa'
import { Tooltip } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { PositionEnum } from 'types/cssTypes'

export const ClaimCallInProgress = (params: any) => {
  const jobStatus: number | null | undefined = params.data?.jobStatus

  if (jobStatus !== 1 && jobStatus !== 2) {
    return <Div>{params.value}</Div>
  }

  const isInProgress = jobStatus === 2
  const tooltipText = isInProgress ? 'Call In Progress' : 'Call Queued'

  return (
    <Div>
      <ToolTipContainer>
        <Tooltip
          tooltipText={tooltipText}
          position={PositionEnum.right}
          positionContent={100}
          positionTooltipArrow={32}
          tooltipStyles={{
            'min-width': '8rem',
            width: '8rem',
            left: '1rem',
            'word-wrap': 'break-word',
          }}
        >
          <span className={!isInProgress ? 'queued' : ''}>{isInProgress ? <FaPhoneVolume /> : <FaPhoneAlt />}</span>
        </Tooltip>
      </ToolTipContainer>
      {params.value}
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  align-items: center;
  svg {
    color: ${({ theme }) => theme.colors.success.dark};
    margin-right: 0.5rem;
    ${({ theme }) => theme.typography.s.normal}
    &.queued {
      color: ${({ theme }) => theme.colors.grey.dark};
    }
  }
`

const ToolTipContainer = styled.div`
  .tooltip-container {
    top: -0.375rem;
    padding: 0.5rem;
    border: solid 1px #ddd!important;
    background-color: #fff!important;
    color: #414755;
    white-space: normal;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;

    .tooltip-arrow {
      left: -1rem!important;
      border-color: transparent #dddddd transparent transparent;
    }
    .tooltip-arrow:after {
      border-color: transparent #ffffff transparent transparent;
    }
`
